const siderBar = {
  profile: "Accueil",
  history: "Histoire",
  setting: "Paramètres",
  promotion: "Offres",
};

export default siderBar;